import { inject, Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiHttpService } from '../../api-http.service';
import { CustomHttpResponse, ClientQuoteTotals } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ClientQuoteTotalsService {
  apiService: ApiHttpService<ClientQuoteTotals> = inject(ApiHttpService<ClientQuoteTotals>);

  getClientQuoteTotalsForClientQuote(iri: string): Observable<ClientQuoteTotals> {
    return this.apiService.get(`${iri}/totals`).pipe(
      take(1),
      map((result: CustomHttpResponse<ClientQuoteTotals>) => result.body),
    );
  }
}
